/**
 * 为了统一处理 sticky 的配置
 * 上面节点必须固定高度，当前节点top取上面高度，否则会有锯齿问题，
 */
export const stickyConfig = {
  headerHeight: 52,
  tabMenuHeight: 38,
  // headerHeight: 108,
  KolStatusHeight: 32,
  TimeToggleHeight: 36,
};

export const getKolStatusOffsetHeight = () => {
  return stickyConfig.tabMenuHeight;
};
